module.exports = __webpack_public_path__ + "img/portfolio-2.70fae66f.jpg";